import React from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

function PrivacyPolicy() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Breadcrumb Hero Section */}
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="breadcrumb-title">
                                    Privacy <span className="breadcrumb-highlight">Policy</span>
                                </h1>
                                <p className="breadcrumb-subtitle" style={{ marginTop: '20px', fontSize: '18px', color: 'rgba(255,255,255,0.9)' }}>
                                    Last Updated: January, 2025
                                </p>
                                <Link to="/contact" style={{ textDecoration: 'none' }}>
                                    <button className="breadcrumb-btn">
                                        <span>CONTACT US</span>
                                        <span className="breadcrumb-arrow">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </span>
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            {/* Privacy Policy Content Section */}
            <section className="about-section py-5">
                <div className="container">
                    {/* Introduction */}
                    <div className="row mb-5">
                        <div className="col-lg-12">
                            <div className="about-content-wrapper">
                                <p className="about-description">
                                    At <span className="text-gradient" style={{ fontWeight: '600' }}>Profit Technologies</span>our we are committed to protecting the privacy and security of your personal information. Your trust is important to us, and this Privacy Policy explains how we collect, use, store, and disclose information when you visit our website or use our IT services.
                                </p>
                                <p className="about-description" style={{ marginTop: '20px' }}>
                                    By accessing or using our website, platform, or services, you agree to this Privacy Policy along with our Terms of Use. We encourage you to review this policy periodically to stay informed about any updates.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Applicability and Scope */}
                    <div className="row mb-5">
                        <div className="col-lg-12">
                            <div className="about-content-wrapper">
                                <h2 className="intro-about-heading mb-4">
                                    Applicability and <span className="text-gradient">Scope</span>
                                </h2>
                                <p className="about-description">
                                    This Privacy Policy applies to all information collected by Profit Technologies through our website, applications, and related digital services (collectively, the "Services"). This policy does not apply to third-party websites or services that have their own privacy policies. We recommend reviewing those policies separately.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Information We Collect */}
                    <div className="row mb-5">
                        <div className="col-lg-12">
                            <div className="about-content-wrapper">
                                <h2 className="intro-about-heading mb-4">
                                    Information We <span className="text-gradient">Collect</span>
                                </h2>
                                <p className="about-description mb-4">
                                    We may collect the following types of information:
                                </p>

                                {/* Personal Information */}
                                <div style={{ background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)', padding: '25px', borderRadius: '12px', marginBottom: '25px', border: '1px solid rgba(102, 126, 234, 0.1)' }}>
                                    <h3 style={{ fontSize: '22px', fontWeight: '600', color: '#1a1a1a', marginBottom: '15px' }}>
                                        <span className="text-gradient">1.</span> Personal Information
                                    </h3>
                                    <p className="about-description mb-3">
                                        Information you voluntarily provide, such as:
                                    </p>
                                    <ul style={{ paddingLeft: '30px', marginBottom: '0', textAlign: 'left' }}>
                                        <li style={{ fontSize: '16px', lineHeight: '1.8', color: '#666', marginBottom: '8px' }}>Name</li>
                                        <li style={{ fontSize: '16px', lineHeight: '1.8', color: '#666', marginBottom: '8px' }}>Email address</li>
                                        <li style={{ fontSize: '16px', lineHeight: '1.8', color: '#666', marginBottom: '8px' }}>Phone number</li>
                                        <li style={{ fontSize: '16px', lineHeight: '1.8', color: '#666', marginBottom: '8px' }}>Company name</li>
                                        <li style={{ fontSize: '16px', lineHeight: '1.8', color: '#666', marginBottom: '0' }}>Project or inquiry-related details</li>
                                    </ul>
                                </div>

                                {/* Technical & Usage Information */}
                                <div style={{ background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)', padding: '25px', borderRadius: '12px', border: '1px solid rgba(102, 126, 234, 0.1)' }}>
                                    <h3 style={{ fontSize: '22px', fontWeight: '600', color: '#1a1a1a', marginBottom: '15px' }}>
                                        <span className="text-gradient">2.</span> Technical & Usage Information
                                    </h3>
                                    <p className="about-description mb-3">
                                        Automatically collected information, including:
                                    </p>
                                    <ul style={{ paddingLeft: '30px', marginBottom: '0', textAlign: 'left' }}>
                                        <li style={{ fontSize: '16px', lineHeight: '1.8', color: '#666', marginBottom: '8px' }}>IP address</li>
                                        <li style={{ fontSize: '16px', lineHeight: '1.8', color: '#666', marginBottom: '8px' }}>Browser and device information</li>
                                        <li style={{ fontSize: '16px', lineHeight: '1.8', color: '#666', marginBottom: '8px' }}>Pages visited and usage patterns</li>
                                        <li style={{ fontSize: '16px', lineHeight: '1.8', color: '#666', marginBottom: '0' }}>Cookies and similar tracking technologies</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* How We Use Your Information */}
                    <div className="row mb-5">
                        <div className="col-lg-12">
                            <div className="about-content-wrapper">
                                <h2 className="intro-about-heading mb-4">
                                    How We Use Your <span className="text-gradient">Information</span>
                                </h2>
                                <p className="about-description mb-3">
                                    We use the collected information to:
                                </p>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div style={{ padding: '20px', background: '#f8f9fa', borderRadius: '10px', height: '100%', borderLeft: '4px solid #667eea' }}>
                                            <p style={{ fontSize: '16px', color: '#666', marginBottom: '0', lineHeight: '1.8' }}>
                                                ✓ Provide and manage our IT services
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div style={{ padding: '20px', background: '#f8f9fa', borderRadius: '10px', height: '100%', borderLeft: '4px solid #764ba2' }}>
                                            <p style={{ fontSize: '16px', color: '#666', marginBottom: '0', lineHeight: '1.8' }}>
                                                ✓ Respond to inquiries and support requests
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div style={{ padding: '20px', background: '#f8f9fa', borderRadius: '10px', height: '100%', borderLeft: '4px solid #667eea' }}>
                                            <p style={{ fontSize: '16px', color: '#666', marginBottom: '0', lineHeight: '1.8' }}>
                                                ✓ Improve our website and user experience
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div style={{ padding: '20px', background: '#f8f9fa', borderRadius: '10px', height: '100%', borderLeft: '4px solid #764ba2' }}>
                                            <p style={{ fontSize: '16px', color: '#666', marginBottom: '0', lineHeight: '1.8' }}>
                                                ✓ Send service-related updates
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div style={{ padding: '20px', background: '#f8f9fa', borderRadius: '10px', height: '100%', borderLeft: '4px solid #667eea' }}>
                                            <p style={{ fontSize: '16px', color: '#666', marginBottom: '0', lineHeight: '1.8' }}>
                                                ✓ Maintain security and prevent fraud
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div style={{ padding: '20px', background: '#f8f9fa', borderRadius: '10px', height: '100%', borderLeft: '4px solid #764ba2' }}>
                                            <p style={{ fontSize: '16px', color: '#666', marginBottom: '0', lineHeight: '1.8' }}>
                                                ✓ Comply with legal obligations
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Sharing of Information */}
                    <div className="row mb-5">
                        <div className="col-lg-12">
                            <div className="about-content-wrapper">
                                <h2 className="intro-about-heading mb-4">
                                    Sharing of <span className="text-gradient">Information</span>
                                </h2>
                                <p className="about-description mb-3">
                                    Profit Technologies does not sell or rent your personal information. We may share information only:
                                </p>
                                <ul style={{ paddingLeft: '30px', textAlign: 'left' }}>
                                    <li style={{ fontSize: '16px', lineHeight: '1.8', color: '#666', marginBottom: '10px' }}>
                                        With trusted service providers assisting us in delivering our services
                                    </li>
                                    <li style={{ fontSize: '16px', lineHeight: '1.8', color: '#666', marginBottom: '10px' }}>
                                        To comply with legal or regulatory requirements
                                    </li>
                                    <li style={{ fontSize: '16px', lineHeight: '1.8', color: '#666', marginBottom: '0' }}>
                                        To protect the rights, safety, and property of Profit Technologies and its users
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Data Security */}
                    <div className="row mb-5">
                        <div className="col-lg-12">
                            <div className="about-content-wrapper">
                                <h2 className="intro-about-heading mb-4">
                                    Data <span className="text-gradient">Security</span>
                                </h2>
                                <p className="about-description">
                                    We implement reasonable technical and organizational security measures to protect your information. However, no method of data transmission over the internet is completely secure, and we cannot guarantee absolute security.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Data Retention */}
                    <div className="row mb-5">
                        <div className="col-lg-12">
                            <div className="about-content-wrapper">
                                <h2 className="intro-about-heading mb-4">
                                    Data <span className="text-gradient">Retention</span>
                                </h2>
                                <p className="about-description">
                                    We retain personal information only for as long as necessary to fulfill the purposes outlined in this policy or as required by law.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Your Rights */}
                    <div className="row mb-5">
                        <div className="col-lg-12">
                            <div className="about-content-wrapper">
                                <h2 className="intro-about-heading mb-4">
                                    Your <span className="text-gradient">Rights</span>
                                </h2>
                                <p className="about-description mb-3">
                                    Subject to applicable laws, you may request to:
                                </p>
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <div style={{ padding: '25px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', borderRadius: '12px', textAlign: 'center', height: '100%' }}>
                                            <div style={{ fontSize: '32px', marginBottom: '10px' }}>📋</div>
                                            <p style={{ fontSize: '16px', color: '#fff', marginBottom: '0', fontWeight: '500' }}>
                                                Access, update, or correct your personal information
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div style={{ padding: '25px', background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)', borderRadius: '12px', textAlign: 'center', height: '100%' }}>
                                            <div style={{ fontSize: '32px', marginBottom: '10px' }}>🗑️</div>
                                            <p style={{ fontSize: '16px', color: '#fff', marginBottom: '0', fontWeight: '500' }}>
                                                Request deletion of your data
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div style={{ padding: '25px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', borderRadius: '12px', textAlign: 'center', height: '100%' }}>
                                            <div style={{ fontSize: '32px', marginBottom: '10px' }}>✋</div>
                                            <p style={{ fontSize: '16px', color: '#fff', marginBottom: '0', fontWeight: '500' }}>
                                                Withdraw consent for data processing
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <p className="about-description" style={{ marginTop: '20px' }}>
                                    Requests can be made by contacting us using the details below.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Third-Party Links */}
                    <div className="row mb-5">
                        <div className="col-lg-12">
                            <div className="about-content-wrapper">
                                <h2 className="intro-about-heading mb-4">
                                    Third-Party <span className="text-gradient">Links</span>
                                </h2>
                                <p className="about-description">
                                    Our Services may contain links to third-party websites. Profit Technologies is not responsible for the privacy practices or content of such websites. We encourage you to review their privacy policies before sharing any personal information.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Changes to This Privacy Policy */}
                    <div className="row mb-5">
                        <div className="col-lg-12">
                            <div className="about-content-wrapper">
                                <h2 className="intro-about-heading mb-4">
                                    Changes to This <span className="text-gradient">Privacy Policy</span>
                                </h2>
                                <p className="about-description">
                                    We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated date. Continued use of our Services constitutes acceptance of the revised policy.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Contact Us */}
                    <div className="row mb-5">
                        <div className="col-lg-12">
                            <div className="about-content-wrapper">
                                <h2 className="intro-about-heading mb-4">
                                    Contact <span className="text-gradient">Us</span>
                                </h2>
                                <p className="about-description mb-4">
                                    If you have any questions or concerns regarding this Privacy Policy, please contact us:
                                </p>
                                <div style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    padding: '40px',
                                    borderRadius: '20px',
                                    boxShadow: '0 20px 60px rgba(102, 126, 234, 0.3)',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{ position: 'absolute', top: '-50px', right: '-50px', width: '200px', height: '200px', background: 'rgba(255, 255, 255, 0.1)', borderRadius: '50%' }}></div>
                                    <div style={{ position: 'absolute', bottom: '-80px', left: '-80px', width: '250px', height: '250px', background: 'rgba(255, 255, 255, 0.05)', borderRadius: '50%' }}></div>

                                    <div style={{ position: 'relative', zIndex: 1 }}>
                                        <h3 style={{ fontSize: '28px', fontWeight: '700', color: '#fff', marginBottom: '25px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <span>🏢</span> Profit Technologies
                                        </h3>
                                        <div>
                                            <p style={{ fontSize: '14px', color: 'rgba(255, 255, 255, 0.8)', marginBottom: '8px', fontWeight: '500' }}>
                                                CONTACT US
                                            </p>
                                            <p style={{ fontSize: '18px', color: '#fff', marginBottom: '0', lineHeight: '1.8' }}>
                                                <Link to="/contact" style={{ color: '#fff', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '10px', transition: 'all 0.3s' }}>
                                                    <span>🌐</span> ProfitTechnologies.org/contact
                                                </Link>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Final Acknowledgment */}
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="about-content-wrapper">
                                <div style={{
                                    textAlign: 'center',
                                    padding: '35px',
                                    background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%)',
                                    borderRadius: '15px',
                                    border: '2px dashed rgba(102, 126, 234, 0.3)'
                                }}>
                                    <p className="about-description" style={{ marginBottom: '0', fontStyle: 'italic', fontWeight: '500', fontSize: '17px' }}>
                                        By using our website and services, you acknowledge that you have read and understood this Privacy Policy.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default PrivacyPolicy;